import type { StackProps } from "@chakra-ui/react";
import { HStack, Text } from "@chakra-ui/react";
import React from "react";
import { IoMdAlert } from "react-icons/io";

export const PromoCodeError = (props: StackProps) => {
  return (
    <HStack
      color="primary-light"
      {...props}
    >
      <IoMdAlert size="20" />
      <Text
        color="primary-light"
        fontSize="14px"
      >
        Please enter a valid promotional code
      </Text>
    </HStack>
  );
};
